var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSd = function SvgSd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#07C166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.267 4.512c.3.034.49.338.39.623L15.19 9.298a.47.47 0 0 1-.842.093l-.313-.5-5.655 3.533-.581-.93A3.174 3.174 0 0 1 8.81 7.12l2.963-1.851-.343-.55a.47.47 0 0 1 .452-.716l4.385.509Zm-5.929 9.653A4.271 4.271 0 0 0 8.775 20l5.754-3.322a3.174 3.174 0 0 0 1.161-4.335l-.548-.95-4.804 2.772Z",
    fill: "#fff"
  })));
};
export default SvgSd;